import React from 'react';
import colors from '../styles/wsr/colors.scss';
var HIGHLIGHT_COLOR = colors.Y30;
export var highlightStyle = { backgroundColor: HIGHLIGHT_COLOR };
var getParts = function (text, searchText) {
    var escapedSearch = searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return text === null || text === void 0 ? void 0 : text.split(new RegExp("(" + escapedSearch + ")", 'gi'));
};
export var highlightText = function (text, highlight) {
    if (!highlight) {
        return text;
    }
    var parts = getParts(text, highlight);
    return parts.map(function (part, index) {
        var shouldHighlight = (part === null || part === void 0 ? void 0 : part.toLowerCase()) === highlight.toLowerCase();
        return (React.createElement("span", { "data-hook": shouldHighlight ? 'highlightText' : '', key: index, style: shouldHighlight ? highlightStyle : {} }, part));
    });
};
//# sourceMappingURL=highlight-utils.js.map